export enum SIGNUP_INVITE_STATUSES {
  ACTIVE = 'active',
  ACCEPTED = 'accepted'
}
